(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-add-modal"] && !Shopify.designMode) return;
  try {
    (function(){
  document.addEventListener('click', function(e){
    var trigger = e.target.closest('[data-quick-add-open]');
    if(!trigger) return;
    var handle = trigger.getAttribute('data-product-handle');
    window.Veloria.openDrawer('quick-add-modal');
    var body = document.querySelector('[data-quick-add-body]');
    var loading = document.querySelector('[data-quick-add-loading]');
    body.style.display = 'none';
    loading.style.display = 'block';

    fetch('/products/' + handle + '.js').then(function(r){ return r.json(); }).then(function(p){
      var variant = p.variants[0];
      var optionsHtml = '';
      var onlyDefaultVariant = p.variants.length === 1 && variant.title === 'Default Title';
      if(p.options.length && !onlyDefaultVariant){
        p.options.forEach(function(opt, idx){
          var optionName = typeof opt === 'string' ? opt : opt.name;
          optionsHtml += '<div class="field"><label class="field__label">' + optionName + '</label><select class="field__input" data-qa-option="' + idx + '">';
          var seen = {};
          p.variants.forEach(function(v){
            var val = v.options[idx];
            if(!seen[val]){ seen[val] = true; optionsHtml += '<option value="' + val + '">' + val + '</option>'; }
          });
          optionsHtml += '</select></div>';
        });
      }
      body.innerHTML = '<div class="quick-add-body__grid">' +
        '<img src="' + (p.featured_image || '') + '" alt="' + p.title + '" width="140" height="140">' +
        '<div>' +
        '<p class="quick-add-body__title">' + p.title + '</p>' +
        '<p class="quick-add-body__price" data-qa-price>' + formatMoney(variant.price) + '</p>' +
        optionsHtml +
        '<button class="btn btn-primary btn-full" data-qa-add data-variant-id="' + variant.id + '">' + (window.veloriaStrings.addToCart || 'Add to Cart') + '</button>' +
        '<a href="/products/' + p.handle + '" class="btn-link" style="display:block;text-align:center;margin-top:12px;">عرض التفاصيل</a>' +
        '</div></div>';

      function formatMoney(cents){
        if(window.Veloria && typeof window.Veloria.formatMoney === 'function') return window.Veloria.formatMoney(cents);
        return String(Number(cents) / 100);
      }

      function findVariant(){
        var selected = Array.prototype.map.call(body.querySelectorAll('[data-qa-option]'), function(s){ return s.value; });
        return p.variants.find(function(v){ return v.options.every(function(o, i){ return selected[i] === undefined || o === selected[i]; }); }) || variant;
      }

      body.querySelectorAll('[data-qa-option]').forEach(function(sel){
        sel.addEventListener('change', function(){
          var v = findVariant();
          body.querySelector('[data-qa-price]').textContent = formatMoney(v.price);
          body.querySelector('[data-qa-add]').setAttribute('data-variant-id', v.id);
        });
      });

      body.querySelector('[data-qa-add]').addEventListener('click', function(btn){
        var vid = this.getAttribute('data-variant-id');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify({ id: vid, quantity: 1 })
        }).then(function(){
          document.dispatchEvent(new CustomEvent('veloria:cart-updated'));
          window.Veloria.closeAllDrawers();
          window.Veloria.openDrawer('cart-drawer');
        });
      });

      loading.style.display = 'none';
      body.style.display = 'block';
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-drawer"] && !Shopify.designMode) return;
  try {
    (function(){
  function renderWishlist(){
    var listEl = document.querySelector('[data-wishlist-list]');
    var emptyEl = document.querySelector('[data-wishlist-empty]');
    var template = document.getElementById('wishlist-item-template');
    if(!listEl || !window.Veloria) return;
    var handles = window.Veloria.getWishlist();
    listEl.innerHTML = '';
    if(handles.length === 0){
      emptyEl.style.display = 'flex';
      listEl.style.display = 'none';
      return;
    }
    emptyEl.style.display = 'none';
    listEl.style.display = 'block';
    handles.forEach(function(handle){
      fetch('/products/' + handle + '.js').then(function(r){ return r.ok ? r.json() : null; }).then(function(p){
        if(!p) return;
        var node = template.content.cloneNode(true);
        var img = node.querySelector('img');
        img.src = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?.*)?$/i, '_300x$1') : '';
        img.alt = p.title;
        node.querySelectorAll('a.cart-item__image, a.cart-item__title').forEach(function(a){ a.href = '/products/' + p.handle; });
        node.querySelector('.cart-item__title').textContent = p.title;
        node.querySelector('.cart-item__price').textContent = (p.price/100).toLocaleString(undefined,{style:'currency',currency:Shopify.currency ? Shopify.currency.active : 'USD'});
        node.querySelector('.wishlist-item__add').addEventListener('click', function(){
          fetch('/cart/add.js', {
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body: JSON.stringify({ id: p.variants[0].id, quantity: 1 })
          }).then(function(){
            document.dispatchEvent(new CustomEvent('veloria:cart-updated'));
            window.Veloria.openDrawer('cart-drawer');
          });
        });
        node.querySelector('.wishlist-item__remove').addEventListener('click', function(){
          var list = window.Veloria.getWishlist().filter(function(h){ return h !== handle; });
          localStorage.setItem('veloria_wishlist', JSON.stringify(list));
          document.dispatchEvent(new CustomEvent('veloria:wishlist-updated'));
        });
        listEl.appendChild(node);
      });
    });
  }
  document.addEventListener('DOMContentLoaded', renderWishlist);
  document.addEventListener('veloria:wishlist-updated', renderWishlist);
})();
  } catch(e) { console.error(e); }
})();

})();
